import CityPageTemplate from "../city-template/CityPageTemplate";
import { auburnMeConfig } from "./data";

export default function AuburnMePage() {
  return <CityPageTemplate config={auburnMeConfig} />;
}